module.exports = __webpack_public_path__ + "static/media/primeship2.eaa7bdc5.png";